export function numberComparator(
  a: number | undefined,
  b: number | undefined
): number {
  if (a === undefined && b === undefined) {
    return 0;
  }
  if (a === undefined) {
    return 1;
  }
  if (b === undefined) {
    return -1;
  }
  if (a === b) {
    return 0;
  }
  return a < b ? -1 : 1;
}

/**
 * Compares two strings lexicographically, but uses numeric sorting when numeric substrings are found
 * Hence, "TME-fab11" will be sorted after "TME-fab2".
 * @param a - string entry
 * @param b - string entry
 */
export function stringComparator(
  a: string | undefined,
  b: string | undefined
): number {
  if (a === undefined && b === undefined) {
    return 0;
  }
  if (a === undefined) {
    return 1;
  }
  if (b === undefined) {
    return -1;
  }
  return a.localeCompare(b, undefined, { numeric: true });
}

export function booleanComparator(
  a: boolean | undefined,
  b: boolean | undefined
): number {
  if (a === b) {
    return 0;
  } else if (a) {
    return -1;
  }
  return 1;
}
